/** 正規表現 */

/** n文字以上の半角英数字 */
export const regHankakuEisu = (n: number) => {
  return `^([a-zA-Z0-9]{${n},})$`
}

/** メールアドレス */
export const email =
  /^[A-Za-z0-9]{1}[A-Za-z0-9_.-]*@{1}[A-Za-z0-9_.-]{1,}\.[A-Za-z0-9]{1,}$/

/** 図版の開始タグ */
export const patternStartTag = /^\[image\sid="\d+"]$/

/** 図版の終了タグ */
export const patternEndTag = /^\[\/image]$/

/** スペースの連続（半角 or 全角） */
// eslint-disable-next-line no-irregular-whitespace
export const patternSerialEmpty = /^( |　)+$/

/** display_name 半角英数字+アンダースコア */
export const regDisplayName = /^[0-9a-zA-Z_]*$/

/** パスワード 英字・数字・記号組み合わせ必須、10文字以上 */
export const regPassword =
  /^(?=.*?[a-zA-Z])(?=.*?\d)(?=.*?[!"#$%&'()*+,-./:;<=>?@[\]^_`{|}~])[!"#$%&'()*+,-./:;<=>?@[\]^_`{|}~\w]{10,64}$/

/** URL /review/novels/ */
export const patternIsReviewPage = /\/review\/novels\//

/** endpoint /v1/novel/[novel_id] */
export const patternNovelApi = /\/v1\/novel\/\d+/

/** endpoint /v1/tieup/novel/[novel_id] */
export const patternTieupNovelApi = /\/v1\/tieup\/novel\/\d+/
